import { render, staticRenderFns } from "./solar-system-dialog.vue?vue&type=template&id=c5933b7c&scoped=true&"
import script from "./solar-system-dialog.vue?vue&type=script&lang=js&"
export * from "./solar-system-dialog.vue?vue&type=script&lang=js&"
import style0 from "./solar-system-dialog.vue?vue&type=style&index=0&id=c5933b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5933b7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VDialog,VIcon})
